import _ from "lodash"

/**
 * 加法运算，避免数据相加小数点后产生多位数和计算精度损失
 * @param num1 加数1
 * @param num2 加数2
 */
export function add(num1: number | string, num2: number | string) {
    const addend1 = Number(num1) || 0;
    const addend2 = Number(num2) || 0;
    const baseNum1 = addend1.toString().split('.')[1]?.length || 0;
    const baseNum2 = addend2.toString().split('.')[1]?.length || 0;
    const baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    return (addend1 * baseNum + addend2 * baseNum) / baseNum;
}